import { RequiredPasswordError } from '../errors/';
export class RequiredPasswordFieldValidation {
    constructor(field) {
        this.field = field;
    }
    validate(input) {
        return !input[this.field] || String(input[this.field]).match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/)
            ? null
            : new RequiredPasswordError();
    }
}
